// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"SingleSectionModal_modalContainer__tF4iu"};